import type { IDashboardReportParams } from '@/interfaces/api/dashboard-report'
import ApiService from '../api.service'

const DashboardResource = {
  generateReport: (payload: IDashboardReportParams) => ApiService.postBlob('/v1/dashboard/report', payload),
}

export default DashboardResource
